import React from "react";
import styles from "./business-profile.module.css";
import AiIcon from "../Icons/ai-icon";
import InfoIcon from "../Icons/info-icon";
import { useSelector } from "react-redux";
import { companyAiInsightsSelector } from "../../Reducers/companyAiInsightsReducer";

const AiInsightsTab = () => {
  const companyAiInsights = useSelector(companyAiInsightsSelector);

  return (
    <div className={styles.aiInsightsRoot}>
      <div className={styles.aiInsightsHeader}>
        <AiIcon width={24} height={24} fill="#00A324" />
        <div className={styles.aiInsightsTitle}>Insights from this week</div>
      </div>

      <div className={styles.aiInsightsList}>
        {companyAiInsights.getSuggestions().length === 0 && (
          <div className={styles.noAiInsightsText}>No insights available</div>
        )}
        {companyAiInsights.getSuggestions().map((suggestion, index) => (
          <div className={styles.aiInsightsItem} key={index}>
            <div className={styles.aiInsightsItemIconWrapper}>
              <InfoIcon width={20} height={20} />
            </div>
            <div className={styles.aiInsightsItemText}>
              {suggestion}
            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
};

export default AiInsightsTab;
